'use client';

import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useTranslations } from 'next-intl';
import { Grid3x3 } from 'lucide-react';

import { useStorageLocationStats } from '../services/storage-locations.queries';

export function StorageLocationsStatCards() {
  const t = useTranslations('storageLocations');
  const { data, isLoading } = useStorageLocationStats();
  const stats = data?.data;

  if (isLoading) {
    return (
      <div className='grid gap-4 sm:grid-cols-2'>
        {Array.from({ length: 2 }).map((_, i) => (
          <Skeleton key={i} className='h-24 w-full rounded-lg' />
        ))}
      </div>
    );
  }

  return (
    <div className='grid gap-4 sm:grid-cols-2'>
      <Card>
        <CardContent className='flex items-center gap-4 px-5 py-6'>
          <div className='min-w-0 flex-1'>
            <p className='text-muted-foreground text-sm font-medium'>
              {t('totalWarehouses')}
            </p>
            <div className='flex items-center gap-2'>
              <p className='text-2xl font-bold'>
                {(stats?.total_warehouses ?? 0).toLocaleString()}
              </p>
              {(stats?.new_warehouses_count ?? 0) > 0 && (
                <p className='text-xs font-semibold text-blue-600 dark:text-blue-400'>
                  {t('newWarehouses', { count: stats!.new_warehouses_count })}
                </p>
              )}
            </div>
          </div>
          <div className='rounded-xl bg-blue-50 p-3 dark:bg-blue-950'>
            <Grid3x3 className='h-5 w-5 text-blue-600 dark:text-blue-400' />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className='flex items-center gap-4 px-5 py-6'>
          <div className='min-w-0 flex-1'>
            <p className='text-muted-foreground text-sm font-medium'>
              {t('definedZones')}
            </p>
            <p className='text-2xl font-bold'>
              {(stats?.defined_zones ?? 0).toLocaleString()}
            </p>
          </div>
          <div className='rounded-xl bg-blue-50 p-3 dark:bg-blue-950'>
            <Grid3x3 className='h-5 w-5 text-blue-600 dark:text-blue-400' />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
